import React, { useEffect, useContext, useState } from "react"
import PropTypes from "prop-types"
import { AppContext } from "../components/context/AppContext"
import { OfferApi } from "../utils/api"
import { MaintenanceModeComponent, PageNotFound } from "../components"
import { OomaGetStartedComponent, OomaWelcomeComponent } from "../components/Ooma"
import AnalyticsService from "../utils/AnalyticsService"
import { ROUTE_PATHS } from "../utils/routes"

const offerId = Number.parseInt(process.env.REACT_APP_OOMA_OFFER_ID)

export const Ooma = () => {
  const { dispatch, state } = useContext(AppContext)
  const [inMaintenanceMode, setInMaintenanceMode] = useState(true)
  const [maintenanceText, setMaintenanceText] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isErrorFetchingMaintenanceText, setIsErrorFetchingMaintenanceText] = useState(false)
  const [landingPageFirstSection, setLandingPageFirstSection] = useState("")
  const [landingPageSecSection, setLandingPageSecSection] = useState("")
  const [isPageNotFound, setIsPageNotFound] = useState(false)

  useEffect(() => {
    AnalyticsService.sendUniquePageview(ROUTE_PATHS.OOMA);
    dispatch({ type: "RESETUSER" })
  }, [dispatch])

  useEffect(() => {
    const checkMaintenanceMode = async () => {

      setIsLoading(true)
      try {
        const clientMaintenanceFlagResult = await OfferApi.getClientAsset("MaintenanceFlag")
        const clientMaintenanceText = await OfferApi.getClientAsset("MaintenanceText")
        const pageNotFound = await OfferApi.getOfferAsset(offerId, "PAGE_NOT_FOUND")
        setIsPageNotFound(pageNotFound)

        if (clientMaintenanceFlagResult.notes.toLowerCase() === "true") {
          setMaintenanceText(clientMaintenanceText.notes)
          setIsLoading(false)
          return
        }

        const offerMaintenanceFlag = await OfferApi.getOfferAsset(offerId, "MaintenanceFlag")
        const offerMaintenanceText = await OfferApi.getOfferAsset(offerId, "MaintenanceText")
        const firstSectionText = await OfferApi.getOfferAsset(offerId, "BODY_TEXT_LANDING_PAGE")
        const secondSectionText = await OfferApi.getOfferAsset(offerId, "BODY_TEXT_LANDING_PAGE2")

        firstSectionText.length === 0 ? setLandingPageFirstSection('') : setLandingPageFirstSection(firstSectionText.notes)
        secondSectionText.length === 0 ? setLandingPageSecSection('') : setLandingPageSecSection(secondSectionText.notes)

        if (offerMaintenanceFlag.notes && offerMaintenanceFlag.notes.toLowerCase() === "true") {
          setMaintenanceText(offerMaintenanceText.notes)
          setIsLoading(false)
          return
        }

        setInMaintenanceMode(false)
      } catch (error) {
        if (error.message === "Unable to retrieve client asset") {
          setIsErrorFetchingMaintenanceText(true)
        }
        setErrorMessage("Something went wrong. Please try again.")
      } finally {
        setIsLoading(false)
      }
    }

    checkMaintenanceMode()
  }, [inMaintenanceMode])

  const ActiveContent = () => (
    <>
      {!isPageNotFound && <OomaGetStartedComponent errorMessage={state.commonError} offerId={offerId} firstSectionText={landingPageFirstSection} secondSectionText={landingPageSecSection} setErrorMessage={setErrorMessage} />}
    </>)

  return (
    <>
      <OomaWelcomeComponent />
      {isPageNotFound && <PageNotFound />}
      {isErrorFetchingMaintenanceText &&
        <div className="text-center container">
          <h1 className="magenta">Temporarily Unavailable</h1>
          <p>This site is currently under going scheduled maintenance. We&apos;ll be back soon.</p>
          <p> Thank you for your patience.</p>
        </div>}
      {isLoading && <div style={{ textAlign: "center" }}>Loading ...</div>}
      {errorMessage.length > 0 && !isLoading && !isErrorFetchingMaintenanceText && <div style={{ textAlign: "center" }}>{errorMessage}</div>}
      {inMaintenanceMode && !isLoading && <MaintenanceModeComponent maintenanceText={maintenanceText} />}
      {!inMaintenanceMode && !isLoading && !isErrorFetchingMaintenanceText && <ActiveContent />}
    </>
  )
}

Ooma.propTypes = {
  history: PropTypes.object
}
